import PieChartLegend from '@app/components/charts/legends/pie-chart-legend';
import ReportContent from '@app/components/reports/components/report-content';
import ReportMetric from '@app/components/reports/components/report-metric';
import { roundNumberToNDecimalPlaces } from '@app/utils/helpers';
import SimplePieChart from '@shared/components/chart/simple-pie-chart';
import Text from '@shared/components/content/text';
import { ChartConfig } from '@shared/components/ui/chart';
import { useCCFReportResult } from '../../ccf-report-result-context';

export default function ResultsSummary() {
  const {
    result: {
      totalCompanyEmissionsTonnes,
      scope1,
      scope2,
      scope3,
      includesScope3,
    },
  } = useCCFReportResult();

  const data = {
    total_emissions: Number(totalCompanyEmissionsTonnes),
    emissions_by_scope: [
      {
        scope: 'scope 1',
        emissions: Number(scope1.totalScopeEmissionsTonnes),
        fill: 'var(--chart-2)',
        pct: Number(scope1.pctOfCompanyEmissions),
      },
      {
        scope: 'scope 2',
        emissions: Number(scope2.totalScopeEmissionsTonnes),
        fill: 'var(--chart-3)',
        pct: Number(scope2.pctOfCompanyEmissions),
      },
      {
        scope: 'scope 3',
        emissions: Number(scope3.totalScopeEmissionsTonnes),
        fill: 'var(--chart-4)',
        pct: Number(scope3.pctOfCompanyEmissions),
      },
    ],
  };

  const chartConfig = {
    emissions: {
      label: 'Emissions',
    },
    'scope 1': {
      label: 'Scope 1',
      color: 'var(--chart-2)',
      unit: 'tCO2e',
    },
    'scope 2': {
      label: 'Scope 2',
      color: 'var(--chart-3)',
      unit: 'tCO2e',
    },
    'scope 3': {
      label: 'Scope 3',
      color: 'var(--chart-4)',
      unit: 'tCO2e',
    },
  } satisfies ChartConfig;

  return (
    <ReportContent>
      <>
        <Text variant="reportBody">
          Emissions values are recorded in tonnes of carbon dioxide equivalent
          (tCO<sub>2</sub>e), a standard unit used to measure the impact of
          greenhouse gas emissions, expressed in terms of the amount of CO₂.
        </Text>
        <ReportMetric
          title="Total emissions"
          value={roundNumberToNDecimalPlaces(data.total_emissions, 2)}
          unit="tCO2e"
          size="lg"
          className="my-8"
        />
      </>
      <>
        <Text variant="h3">Emissions by scope</Text>
        <div className="space-y-3">
          {data.emissions_by_scope.map((scope) => {
            return (
              <div key={scope.scope}>
                <PieChartLegend
                  name={scope.scope}
                  emissions={scope.emissions}
                  percentage={scope.pct}
                  color={scope.fill}
                  notIncluded={scope.scope === 'scope 3' && !includesScope3}
                />
              </div>
            );
          })}
        </div>
        <SimplePieChart
          nameKey="scope"
          dataKey="emissions"
          chartData={data.emissions_by_scope.reverse()}
          chartConfig={chartConfig}
          innerRadius={80}
          className="h-96 w-full"
        />
      </>
    </ReportContent>
  );
}
